<div class="skeletor-detail">
  <div class="skeletor-header">
    <div class="skeletor-header-left">
      <p-skeleton [width]="'14rem'" [height]="'1.2rem'" />
      <p-skeleton [width]="'10rem'" [height]="'1rem'" />
      
    </div>
    <div class="skeletor-header-right">
      <p-skeleton [width]="'9rem'" [height]="'2rem'" />
      <p-skeleton [width]="'7rem'" [height]="'2rem'" />
      <p-skeleton [width]="'6rem'" [height]="'2rem'" />
    </div>
  </div>

  <div class="skeletor-content">
    <div class="skeletor-col-left">
      <div class="skeletor-panel">
        <p-skeleton width="60%" class="mb-2" />
        <p-skeleton width="40%" class="mb-2" />
        <p-skeleton height="2rem" class="mb-2" />
        <p-skeleton width="50%" height="4rem" />
        <p-skeleton width="60%" class="mb-2" />
        <p-skeleton width="40%" class="mb-2" />
        <p-skeleton width="60%" class="mb-2" />
        <p-skeleton width="40%" class="mb-2" />
        
      </div>

      <div class="skeletor-panel">
       <p-skeleton width="60%" class="mb-2" />
        <p-skeleton width="40%" class="mb-2" />
        <p-skeleton height="2rem" class="mb-2" />
        <p-skeleton width="50%" height="4rem" />
        <p-skeleton width="60%" class="mb-2" />
        <p-skeleton width="40%" class="mb-2" />
        <div class="skeletor-list">
          <div class="skeletor-list-item" *ngFor="let i of rows">
            <p-skeleton [width]="'60%'" [height]="'1rem'" />
            <p-skeleton [width]="'20%'" [height]="'1rem'" />
          </div>
        </div>
      </div>
    </div>

    <div class="skeletor-col-right">
      <div class="skeletor-panel">
        <p-skeleton [width]="'10rem'" [height]="'1rem'" />
        <p-skeleton width="60%" class="mb-2" />
        <p-skeleton width="40%" class="mb-2" />
        <p-skeleton height="2rem" class="mb-2" />
        <p-skeleton width="50%" height="4rem" />
        <div class="skeletor-list">
          <div class="skeletor-list-item" *ngFor="let i of rows">
            <p-skeleton [width]="'30%'" [height]="'1rem'" />
            <p-skeleton [width]="'60%'" [height]="'1rem'" />
          </div>
        </div>
      </div>
      <div class="skeletor-panel">
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <p-skeleton width="60%" class="mb-2" />
        <p-skeleton width="40%" class="mb-2" />
        <p-skeleton height="2rem" class="mb-2" />
        <p-skeleton width="50%" height="4rem" />
        <div class="skeletor-list">
          <div class="skeletor-list-item" *ngFor="let i of rows">
            <p-skeleton [width]="'35%'" [height]="'1rem'" />
            <p-skeleton [width]="'55%'" [height]="'1rem'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
